import { combineReducers } from "redux";
import { SAVE_ACTIVE_TOPHEADER_COMPONENT, GET_USER_ORG_NAME_SUGGESTIONS_SUCCESS, GET_LEFT_NAVIGATION_SUCCESS } from "../actions/actionConstants";

import associatedParties from './associatedPartiesReducer';
import orgAccess from './orgAccessReducer';
import notification from "./notification";
import globalSearch from "./globalSearchReducer";
import manageProfile from "./manageProfileReducer";

const initialState = {
    activeHeader: "",
    orgSuggestion: [],
    leftNavigation: []
};

const headerObject = function (state = initialState, action) {
    switch (action.type) {
        case SAVE_ACTIVE_TOPHEADER_COMPONENT: {
            return Object.assign({}, state, action.payload);
        }
        case GET_USER_ORG_NAME_SUGGESTIONS_SUCCESS: {
            return Object.assign({}, state, action.payload);
        }
        case GET_LEFT_NAVIGATION_SUCCESS: {
            return Object.assign({}, state, action.payload);
        }
        default:
            return state;
    }
}

export default combineReducers({
    associatedParties, orgAccess, notification, globalSearch, headerObject, manageProfile
});